export default "__VITE_ASSET__0A1lUK6i__"